import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=1500739c&scoped=true"
import script from "./Distribution.vue?vue&type=script&lang=js"
export * from "./Distribution.vue?vue&type=script&lang=js"
import style0 from "./Distribution.vue?vue&type=style&index=0&id=1500739c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1500739c",
  null
  
)

export default component.exports